import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isObject from 'lodash/isObject';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import StoreContainer from './StoreContainer';
import IntlContainer from './IntlContainer';
import RouterContainer from './RouterContainer';
import UrlGeneratorContainer from './UrlGeneratorContainer';
var propTypes = {
  store: PropTypes.oneOfType([PropTypes.shape(_objectSpread({}, StoreContainer.propTypes)), PropTypes.bool]),
  intl: PropTypes.oneOfType([PropTypes.shape(_objectSpread({}, IntlContainer.propTypes)), PropTypes.bool]),
  urlGenerator: PropTypes.oneOfType([PropTypes.shape(_objectSpread({}, UrlGeneratorContainer.propTypes)), PropTypes.bool]),
  router: PropTypes.oneOfType([PropTypes.shape(_objectSpread({}, RouterContainer.propTypes, {
    memoryHistory: PropTypes.bool,
    createHistory: PropTypes.func
  })), PropTypes.bool]),
  children: PropTypes.node.isRequired
};
var defaultProps = {
  store: null,
  intl: null,
  urlGenerator: null,
  router: null
};

var Container =
/*#__PURE__*/
function (_Component) {
  _inherits(Container, _Component);

  function Container(props) {
    var _this;

    _classCallCheck(this, Container);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Container).call(this, props));
    _this.renderRouter = _this.renderRouter.bind(_assertThisInitialized(_this));
    _this.renderIntl = _this.renderIntl.bind(_assertThisInitialized(_this));
    _this.renderUrlGenerator = _this.renderUrlGenerator.bind(_assertThisInitialized(_this));
    _this.renderStore = _this.renderStore.bind(_assertThisInitialized(_this));
    _this.history = props.router !== false ? _this.createHistory() : null;
    return _this;
  } // eslint-disable-next-line class-methods-use-this


  _createClass(Container, [{
    key: "createHistory",
    value: function createHistory() {
      var router = this.props.router;
      var memoryHistory = isObject(router) ? get(router, 'memoryHistory', false) : false;
      var createHistory = isObject(router) ? get(router, 'createHistory', null) : null;

      if (createHistory !== null) {
        return createHistory(router);
      }

      return memoryHistory ? createMemoryHistory() : createBrowserHistory();
    }
  }, {
    key: "renderRouter",
    value: function renderRouter(children) {
      var router = this.props.router;

      var _ref = isObject(router) ? router : {},
          memoryHistory = _ref.memoryHistory,
          createHistory = _ref.createHistory,
          routerProps = _objectWithoutProperties(_ref, ["memoryHistory", "createHistory"]);

      return React.createElement(RouterContainer, _extends({
        history: this.history
      }, routerProps), children);
    }
  }, {
    key: "renderIntl",
    value: function renderIntl(children) {
      var intl = this.props.intl;
      return React.createElement(IntlContainer, intl, children);
    }
  }, {
    key: "renderUrlGenerator",
    value: function renderUrlGenerator(children) {
      var urlGenerator = this.props.urlGenerator;
      return React.createElement(UrlGeneratorContainer, urlGenerator, children);
    }
  }, {
    key: "renderStore",
    value: function renderStore(children) {
      var _this2 = this;

      var _this$props = this.props,
          store = _this$props.store,
          router = _this$props.router;
      return React.createElement(StoreContainer, _extends({
        getReducers: function getReducers(reducers) {
          return router !== false ? _objectSpread({
            router: connectRouter(_this2.history)
          }, reducers) : reducers;
        },
        getMiddlewares: function getMiddlewares(middlewares) {
          return router !== false ? [routerMiddleware(_this2.history)].concat(_toConsumableArray(middlewares)) : middlewares;
        }
      }, store), children);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          store = _this$props2.store,
          intl = _this$props2.intl,
          urlGenerator = _this$props2.urlGenerator,
          router = _this$props2.router,
          children = _this$props2.children;
      var renderMethods = [{
        test: router !== false,
        render: this.renderRouter
      }, {
        test: urlGenerator !== false,
        render: this.renderUrlGenerator
      }, {
        test: intl !== false,
        render: this.renderIntl
      }, {
        test: store !== false,
        render: this.renderStore
      }];
      return renderMethods.reduce(function (element, _ref2) {
        var test = _ref2.test,
            render = _ref2.render;
        return test ? render(element) : element;
      }, children);
    }
  }]);

  return Container;
}(Component);

Container.propTypes = propTypes;
Container.defaultProps = defaultProps;
export default Container;


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/Container.js
// module id = null
// module chunks = 